// Landing page color configurations
// Each landing type has its own color palette for differentiation

import { LandingColors, LandingType } from './landing-content/types';

export const LANDING_COLORS: Record<LandingType, LandingColors> = {
  escuelas: {
    primary: '#059669',
    secondary: '#0D9488',
    gradient: 'from-[#059669] to-[#0D9488]',
    gradientFrom: '#059669',
    gradientTo: '#0D9488',
    accent: '#059669',
    accentBg: 'bg-[#059669]/10',
    hover: '#047857',
  },
  jams: {
    primary: '#4F46E5',
    secondary: '#6366F1',
    gradient: 'from-[#4F46E5] to-[#6366F1]',
    gradientFrom: '#4F46E5',
    gradientTo: '#6366F1',
    accent: '#4F46E5',
    accentBg: 'bg-[#4F46E5]/10',
    hover: '#4338CA',
  },
  salas: {
    // Azul confiable tipo Zillow/marketplace (antes negro/marrón #26251E).
    primary: '#2A6DF4',
    secondary: '#1B4FC4',
    gradient: 'from-[#2A6DF4] to-[#1B4FC4]',
    gradientFrom: '#2A6DF4',
    gradientTo: '#1B4FC4',
    accent: '#2A6DF4',
    accentBg: 'bg-[#2A6DF4]/10',
    hover: '#1B4FC4',
  },
} as const;

// Helper to get Tailwind classes with dynamic colors
export const getLandingColorClasses = (type: LandingType) => {
  const colors = LANDING_COLORS[type];
  return {
    // Buttons
    buttonPrimary: `bg-[${colors.primary}] hover:bg-[${colors.primary}]/90`,
    buttonOutline: `border-[${colors.primary}] text-[${colors.primary}] hover:bg-[${colors.primary}]/5`,

    // Text
    textPrimary: `text-[${colors.primary}]`,

    // Backgrounds
    bgAccent: `bg-[${colors.primary}]/10`,
    bgGradient: `bg-gradient-to-r ${colors.gradient}`,

    // Borders
    borderPrimary: `border-[${colors.primary}]`,

    // Decorative
    blobColor: `bg-[${colors.primary}]/5`,
    blobColorStrong: `bg-[${colors.primary}]/10`,
  };
};

// Default colors (for backwards compatibility)
export const DEFAULT_LANDING_COLORS = LANDING_COLORS.escuelas;
